import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-emerald-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Trusted by local businesses across South Devon
          </p>
        </div>

        {/* Awaiting testimonials message */}
        <div className="max-w-2xl mx-auto">
          <Card className="border-2 border-emerald-100 bg-white">
            <CardContent className="p-12 text-center">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-emerald-100 to-teal-100 flex items-center justify-center">
                <Star className="text-emerald-600" size={40} />
              </div>
              <p className="text-xl text-gray-700 leading-relaxed">
                Awaiting our first testimonials
              </p>
              <p className="text-gray-600 mt-4">
                We're a new family-run business in South Devon, dedicated to providing simple, honest energy solutions for local businesses.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;